import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button
} from "reactstrap";

import {
    FiClock,
    FiCode,
    FiBox,
    FiSettings,
    FiFileText,
    FiBriefcase,
    FiDollarSign,
    FiMonitor,
    FiVideo
} from "react-icons/fi";

import "./CourseDetails.css";

const durationItems = [
    {
        icon: <FiCode />,
        title: "Programming Language Training",
        duration: "1 Month",
        description:
            "Learn essential programming languages like C# .NET or C++ to write scripts and interact with CAD software via its API."
    },
    {
        icon: <FiBox />,
        title: "CAD Design Training",
        duration: "1 Month",
        description:
            "Gain fundamental CAD design knowledge, covering topics such as part design, assembly, and drafting, to comprehend CAD software principles."
    },
    {
        icon: <FiSettings />,
        title: "CAD API Training",
        duration: "Minimum 1 Month",
        description:
            "Focus on the API of your chosen CAD software, dedicating a minimum of one month to understand CAD automation and customization."
    },
    {
        icon: <FiFileText />,
        title: "Assignments and Sample Projects",
        duration: "Practical Training",
        description:
            "Work on assignments and complete a sample project during CAD API training to reinforce practical skills."
    },
    {
        icon: <FiBriefcase />,
        title: "Additional Project-Based Training",
        duration: "Recommended",
        description:
            "Participate in extra project-based training for real-world experience, portfolio development, and hands-on expertise."
    }
];

const batchTimings = [
    {
        title: "Morning Batch",
        time: "7am – 8am",
        icon: <FiClock />
    },
    {
        title: "Evening Batch",
        time: "9pm – 10pm",
        icon: <FiClock />
    },
    {
        title: "Weekend Batch",
        time: "11am – 1pm",
        icon: <FiClock />
    }
];

const trainingPlatforms = [
    {
        name: "Zoom",
        icon: <FiVideo />
    },
    {
        name: "Microsoft Teams",
        icon: <FiMonitor />
    },
    {
        name: "Google Meet",
        icon: <FiVideo />
    }
];

function CourseDetails() {
    return (
        <section className="course-details-section">
            <Container>

                {/* Section Header */}
                <div className="course-details-header">
                    <span className="course-details-eyebrow">
                        COURSE DETAILS
                    </span>

                    <h2>
                        Structured Learning for
                        <span> CAD Professionals</span>
                    </h2>

                    <p>
                        Build your skills step-by-step through programming,
                        CAD design, API training, assignments, and practical
                        project-based learning.
                    </p>
                </div>

                {/* Duration */}
                <div className="course-details-block">

                    <div className="course-details-block-heading">
                        <div className="course-details-heading-icon">
                            <FiClock />
                        </div>

                        <div>
                            <h3>Duration & Training Structure</h3>
                            <p>
                                A practical learning path designed to build
                                strong CAD automation skills.
                            </p>
                        </div>
                    </div>

                    <Row className="g-4">
                        {durationItems.map((item, index) => (
                            <Col
                                lg="4"
                                md="6"
                                sm="12"
                                key={index}
                            >
                                <Card className="duration-card h-100">
                                    <CardBody>

                                        <div className="duration-card-top">
                                            <div className="duration-icon">
                                                {item.icon}
                                            </div>

                                            <span className="duration-badge">
                                                {item.duration}
                                            </span>
                                        </div>

                                        <h4>{item.title}</h4>

                                        <p>
                                            {item.description}
                                        </p>

                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Fees */}
                <div className="fees-section">

                    <div className="fees-content">
                        <div className="fees-icon">
                            <FiDollarSign />
                        </div>

                        <div>
                            <span>FEES STRUCTURE</span>

                            <h3>
                                Get complete course fee details
                            </h3>

                            <p>
                                Check the latest fees structure and available
                                training options.
                            </p>
                        </div>
                    </div>

                    <Button
                        color="primary"
                        href="/fees-structure"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fees-button"
                    >
                        View Fees Details
                    </Button>

                </div>

                {/* Batch Timings */}
                <div className="course-details-block batch-block">

                    <div className="course-details-block-heading">
                        <div className="course-details-heading-icon">
                            <FiClock />
                        </div>

                        <div>
                            <h3>Batch Timings</h3>
                            <p>
                                Choose a schedule that fits your availability.
                            </p>
                        </div>
                    </div>

                    <Row className="g-4">

                        {batchTimings.map((batch, index) => (
                            <Col
                                lg="4"
                                md="4"
                                sm="12"
                                key={index}
                            >
                                <Card className="batch-card h-100">
                                    <CardBody>

                                        <div className="batch-icon">
                                            {batch.icon}
                                        </div>

                                        <h4>
                                            {batch.title}
                                        </h4>

                                        <div className="batch-time">
                                            {batch.time}
                                        </div>

                                        <span>
                                            IST
                                        </span>

                                    </CardBody>
                                </Card>
                            </Col>
                        ))}

                    </Row>
                </div>

                {/* Mode of Training */}
                <div className="training-mode-section">

                    <div className="training-mode-content">

                        <div className="training-mode-icon">
                            <FiMonitor />
                        </div>

                        <div>
                            <span className="training-mode-label">
                                MODE OF TRAINING
                            </span>

                            <h3>
                                Live & Interactive Online Training
                            </h3>

                            <p>
                                Learn directly from instructors through live
                                interactive sessions using your preferred
                                online meeting platform.
                            </p>
                        </div>

                    </div>

                    <Row className="g-3">

                        {trainingPlatforms.map((platform, index) => (
                            <Col
                                lg="4"
                                md="4"
                                sm="12"
                                key={index}
                            >
                                <div className="platform-card">

                                    <div className="platform-icon">
                                        {platform.icon}
                                    </div>

                                    <span>
                                        {platform.name}
                                    </span>

                                </div>
                            </Col>
                        ))}

                    </Row>

                </div>

            </Container>
        </section>
    );
}

export default CourseDetails;